import { memo } from 'react';
import styled from 'styled-components';
import { Skeleton } from '@frameio/vapor';
import { theme } from '@frameio/vapor-theme';
import { ICON_SIZE } from './WorkspaceRow';

export const LoadingMoreSkeleton = memo(() => (
  <Container>
    {new Array(NUM_ENTRIES).fill(0).map((_, index: number) => (
      <SkeletonRowContainer key={index}>
        <StyledSkeletonAvatar rounded={false} />
        <StyledSkeletonText height={12} rounded={false} style={{ flex: 1 }} />
      </SkeletonRowContainer>
    ))}
  </Container>
));

const NUM_ENTRIES = 5;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  &:first-child {
    margin-top: calc(-1 * ${theme.spaces[4]});
  }
`;

const SkeletonRowContainer = styled.div`
  align-items: center;
  display: flex;
  gap: ${theme.spaces[12]};
  padding-bottom: ${theme.spaces[4]};
  padding-left: ${theme.spaces[12]};
  padding-right: ${theme.spaces[16]};
  padding-top: ${theme.spaces[4]};
`;

const StyledSkeletonAvatar = styled(Skeleton)`
  background-color: ${theme.colors.components.skeleton.background};
  height: ${ICON_SIZE}px;
  width: ${ICON_SIZE}px;
`;

const StyledSkeletonText = styled(Skeleton)`
  background-color: ${theme.colors.components.skeleton.background};
  padding: ${theme.spaces[2]};
`;
